<template>
  <div id="widget-modal"
    @click.self="close(1)"
    @keydown.esc="close(1)">
    <div :class="makeDialogCSS()">
      <!-- クローズ時のダイアログ -->
      <CloseDialogMessage
        :color="color"
        :step="step"
        @createPreAccount="createPreAccount"
        @close="close"
        v-if="step==1||step==2"
      />
      <!-- ダイアログヘッダー部 -->
      <DialogHeader
        :data="data"
        :color="color"
        :search="search"
        :showModalStatus="showModalStatus"
        :target="target"
        :targetIcon="targetIcon"
        :targetModel="targetModel"
        :tabName="tabName"
        :widgetData="widgetData"
        @close="close"
        @setStep="setStep"
        @backModal="backModal"
        @initScenario="initScenario"
      />
      <div class="form-std">
        <transition name="up">
          <!-- アイコン一覧表現 -->
          <SelectConvVender
            ref="convender"
            key=1
            v-if="color.view_template === 0&&isMobile() == false&&showModalStatus === 1"
            @tab-name="getTabTitle"
            @openCB="openCB"
            @changeModalDialog="changeModalDialog"/>
          <SelectConvVenderMobile
            ref="convender"
            key=2
            @tab-name="getTabTitle"
            @search="searchTitle"
            @exit-search="exitSearch"
            @openCB="openCB"
            @changeModalDialog="changeModalDialog"
            v-if="color.view_template === 0&&isMobile() == true&&showModalStatus === 1"/>
          <SelectMenu
            ref="menu"
            key=3
            :color="color"
            :widgetData="widgetData"
            :targetID="targetID"
            :seeker="seeker"
            :data="data"
            :selectTagNewMsg="selectTagNewMsg"
            @changeModalDialog="changeModalDialog"
            v-if="color.view_template >= 1&&showModalStatus === 1"
            @openCB="openCB"/>
          <ChatDialog
            key=4
            :headerType="headerType"
            :headerTitle="headerTitle"
             v-if="showModalStatus === 2"/>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import ChatDialog             from '@/views/ChatWidget/ChatDialog'
import SelectMenu             from '@/views/ChatWidget/SelectMenu'
import CloseDialogMessage     from '@/components/ChatWidgetDialog/organisms/CloseDialogMessage'
import DialogHeader           from '@/components/ChatWidgetDialog/organisms/DialogHeader'
import SelectConvVender       from '@/components/ChatWidgetDialog/organisms/SelectConvVender'
import SelectConvVenderMobile from '@/components/ChatWidgetDialog/organisms/SelectConvVenderMobile'

export default {
  components: {
    ChatDialog,
    CloseDialogMessage,
    DialogHeader,
    SelectMenu,
    SelectConvVender,
    SelectConvVenderMobile
  },
  props: {
    showModalStatus: {
      type: Number,
      required: true
    },
    scenario: {
      type: Object,
      required: false
    },
    targetID: {
      type: String,
      required: false
    },
    minipk: {
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    seeker: {
      type: Object,
      required: true
    },
    target: {
      type: String,
      required: true
    },
    targetIcon: {
      type: String,
      required: true
    },
    targetModel: {
      type: String,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
    color: {
      type: Object,
      required: true
    },
    selectTagNewMsg: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      name: '',
      intarnal: {},
      tabName: 'ロボ一覧',
      search: false,
      step: 0,
      email: '',
      selectBotInfo: [],
      headerTitle: '',
      headerType: -1,
    }
  },
  methods: {
    setStep (num) {
      this.step = num
    },
    close (num) {
      this.step = 0
      this.$emit('close', num)
    },
    createPreAccount (email) {
      this.$store.dispatch('signup/createPreAccount', {
        email:     this.email,
        companyid: this.data.ckey,
        sessionid: this.seeker.id,
        fromurl:   this.data.url
      })
      this.step = 2
    },
    initScenario () {
      this.$store.dispatch('chatbot/getScenarioOne', {
        companyid: this.data.ckey,
        scenarioName: this.scenario.name,
        node: 'INITIALIZE',
        rate: this.color.thinking_rate,
        minipk: this.minipk
      })
      localStorage.removeItem('scenariolv_' + (this.minipk || this.targetID))
      this.mountChatPage()
      this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
    },
    backModal () {
      this.$emit('backModal')
    },
    getTabTitle (name) {
      this.tabName = name
    },
    isMobile () {
      if (this.data.useragent.match(/(iPhone|iPod|Android.*Mobile)/i)) return true
      else return false
    },
    makeColor () {
      return {
        'background': this.color.iconBg + '!important',
        'color': this.color.iconFr + '!important'
      }
    },
    searchTitle () {
      this.search = true
    },
    exitSearch () {
      this.search = false
    },
    mountChatPage () {
      this.$store.dispatch('chatbot/mountChatPage')
    },
    openCB (headerTitle, headerType) {
      if (headerTitle) {
        this.headerTitle = headerTitle
      }
      this.headerType = headerType
    },
    changeModalDialog () {
      this.$emit('changeModalDialog')
    },
    backModal () {
      this.$emit('backModal')
    },
    makeDialogCSS () {
      if (this.isMobile()) {
        return 'modal-body-dt-mb'
      } else {
        return 'modal-body-dt'
      }
    },
  }
}
</script>

<style scoped>
#widget-modal {
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  pointer-events: auto;
  transition-delay: 0.01s;
  transition-duration: 0.4s;
}
.form-std {
  padding: 0px;
  height: calc(100% - 72px);
  overflow: hidden;
  -ms-overflow-style:none;
  overflow: -moz-scrollbars-none;
}
.form-profile {
  padding: 0px;
  height: calc(100% - 127px);
  overflow: hidden;
  -ms-overflow-style:none;
  overflow: -moz-scrollbars-none;
}
.modal-body-dt {
  background: rgba(248, 248, 248, 1);
  width:  calc(100% - 10px);
  height: calc(100% - 10px);
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}
.modal-body-dt-mb {
  background: rgba(248, 248, 248, 1);
  width:  100%;
  height: 100%;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}
.modal-footer {
  height: 64px;
  width: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.modal-footer-mb {
  height: 64px;
  width: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 0;
}
.footer-message {
  width: calc(100% - 120px);
  height: 50px;
  color: black;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.footer-button {
  height: 50px;
  width: 50px;
  font-size: 34px;
  line-height: 0;
  background: rgba(0, 0, 0, 0);
  border-radius: 0;
  color: white;
}
@media screen and (max-width: 500px) {
  .form {
    height: calc(100% - 50px);
  }
  .form-regacy {
    height: calc(100% - 112px);
  }
  .form-profile {
    height: calc(100% - 112px);
  }
  .footer-message {
    font-size: 14px;
    padding: 5px;
  }
}

.up-enter-active, .up-leave-active {
  transition: .5s
}
.up-enter, .up-leave {
  transform: translateY(100%);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/ChatWidget/Dialog.vue